import Image from "next/legacy/image";
import { getAlternativePostPath } from '@helpers';
import { addTrailingSlash } from '@utils';

export interface SideBarPostData {
  slug?: string | null;
  featuredImage?: {
    node?: { sourceUrl?: string | null | undefined } | string | null;
  } | null;
  categories?: {
    nodes?: ({ slug?: string | null } | null | undefined)[] | null;
  } | null;
  title?: string | null;
}

export const SideBarPosts: React.FC<{
  posts?: (SideBarPostData | undefined | null)[] | null;
  showIndex?: boolean;
}> = ({ posts, showIndex }) => {
  return (
    <ul className='mb-9'>
      {posts?.map(
        (post, index) =>
          post && (
            <li key={post.slug} className='relative my-3 flex'>
              {showIndex && (
                <span className='absolute left-0 top-0 z-10 inline-table h-6 w-6 bg-secondary text-center text-white'>
                  {index + 1}
                </span>
              )}
              {/* prefetchさせない/spa動作させないためにnext/linkを使わない */}
              <a
                className='flex items-start hover:opacity-80'
                href={addTrailingSlash(
                  `/knowledge/${getAlternativePostPath(post) || 'blog'}/${
                    post.slug
                  }`
                )}
              >
                <div className='shrink-0'>
                  <Image
                    src={
                      (typeof post.featuredImage?.node === 'string'
                        ? post.featuredImage.node
                        : post.featuredImage?.node?.sourceUrl) || ''
                    }
                    width={90}
                    height={60}
                    objectFit='cover'
                    alt='cover'
                  />
                </div>
                <div className='ml-2'>{post.title}</div>
              </a>
            </li>
          )
      )}
    </ul>
  );
};

export default SideBarPosts;
